import Party from './Party'
import { ElectionOutcome } from './TypeHelper'

export default class PartyResult {
  // TODO: protect these to make them read-only
  public voteCount: number = 0
  public votePercent: number = 0
  public seatCount: number = 0
  public seatPercent: number = 0
  public outcome: ElectionOutcome = 'no-seats'
  protected _party: Party

  public static fromPartyAndVote(party: Party, voteCount: number): PartyResult {
    const partyResult = new PartyResult(party)
    partyResult.voteCount = voteCount
    return partyResult
  }

  public constructor(party: Party) {
    this._party = party
  }

  public clone(): PartyResult {
    const clone = new PartyResult(this._party)
    clone.voteCount = this.voteCount
    clone.votePercent = this.votePercent
    clone.seatCount = this.seatCount
    clone.seatPercent = this.seatPercent
    clone.outcome = this.outcome
    return clone
  }

  public get party(): Party {
    return this._party
  }
}
